import { useEffect, useRef } from 'react';

/**
 * Runs a callback after a debounce delay whenever deps change.
 * The callback is invoked immediately when delay is 0.
 */
export default function useDebouncedEffect(callback, delay, deps) {
    const timeoutRef = useRef(null);

    useEffect(() => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);

        timeoutRef.current = setTimeout(callback, delay);

        return () => clearTimeout(timeoutRef.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
